module.exports = __webpack_public_path__ + "img/1sb_five_stars_selected_shopper_d.1f714e3.svg";